import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CopyToClipboard from 'react-copy-to-clipboard';
import {useTranslation} from 'react-i18next';

export default function SigningSecretDialog({ isOpen, onCancel, secretKey }) {
  const { t } = useTranslation('developer');

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="alert-dialog-title"
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return false;
        }
        onCancel();
      }}
    >
      <DialogTitle>{t('signing secret title')}</DialogTitle>
      <DialogContent dividers>
        <Typography>{t('signing secret text')}</Typography>
        <TextField
          multiline
          value={secretKey}
          disabled
          variant="outlined"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Copy" placement="top">
                  <CopyToClipboard text={secretKey}>
                    <IconButton aria-label="copy">
                      <FileCopyIcon fontSize="medium" />
                    </IconButton>
                  </CopyToClipboard>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Tooltip title="Copy" placement="top">
          <CopyToClipboard text={secretKey}>
            <Button variant="contained" onClick={onCancel} color="primary">
              {t('close & copy to clipboard')}
            </Button>
          </CopyToClipboard>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
}
